module.exports = __webpack_public_path__ + "img/sao-miguel-grandes-cantorias.c9dbae2e.jpg";